const avatarColorConfig = {
    color: 'var(--kt-primary-light)',
    fgColor: 'var(--kt-primary)',
    title: '',
    style: 'cursor-default'
};

export {
    avatarColorConfig
}